export const servicesCardsTextsExperimentGroups = {
  default: 'a_default',
  views: 'b_views',
  shows: 'c_shows',
  redesign: 'd_redesign',
} as const;

export const servicesCardsTextsExperimentName = 'mnz_fvu_message_redesign';

type Val<T extends Object> = T[keyof T];

export type TServicesCardsTextsExperimentGroupsNames = Val<typeof servicesCardsTextsExperimentGroups>;
